<template>
  <div>
    <div
      class="d-flex flex-column align-items-center align-items-lg-start"
    >
      <div class="d-flex">
        <span class="pdp-buynow-price pdp-h3 mr-2">
          {{ selectedPriceText }}
        </span>
        <span class="pdp-buynow-old-price my-auto">
          {{ strikethroughText }}
        </span>
      </div>
    </div>
    <div class="d-flex">
      <div
        class="px-2 py-1 rounded save-badge d-inline-block"
        :class="{
          'bg-light-dollar' : variant === 'green',
          'bg-brick text-white' : variant === 'red',
        }"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    originalPrice: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: true,
    },
    selectedPriceText: {
      type: String,
      default: '',
    },
  },
  computed: {
    text() {
      const savings = this.originalPrice - this.price;
      return `Save ${this.$options.filters.currencyWithOptionalDecimal(savings)}`;
    },
    strikethroughText() {
      return `Worth ${this.$options.filters.currencyWithOptionalDecimal(this.originalPrice)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/dorado/themes/dorado';
@import '../../styles/utils/breakpoints';

.pdp-buynow-price {
  font-weight: 500;
}

.pdp-buynow-old-price {
  color: $grace;
  font-size: 14px;
  font-weight: 400;
  text-decoration: line-through;
}

.save-badge {
  color: $gray-900;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

/*! purgecss start ignore */

.bg-light-dollar {
  background-color: #6ad989; // not in dorado
}

.bg-brick {
  background-color: $brick;
}

/*! purgecss end ignore */

@include media-breakpoint-down(md) {
  .save-badge {
    margin: 0 auto;
  }
}
</style>
